/* eslint-disable */
import { CREATE_USER_PROFILE } from '../UserProfile.types';

/**
 * Close the sidebar
 * @param {data} data The data
 * @returns {ActionCreator<FromPayload<null, {}, SIDEBAR_CLOSE>>} The created `Action`
 */
const createUserProfile = (data) => ({ fromPayload }) => {
  return fromPayload(data.profile, {}, CREATE_USER_PROFILE);
};

export default createUserProfile;
